module.exports = __webpack_public_path__ + "images/emoji/pisces.0307ce45dae6253063b3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pisces.png
// module id = BSu5
// module chunks = 24